var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h2',[_vm._v("Polygon Token Transfer DApp PoC (Testnet)")]),_c('ShadowContainer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }